/* eslint-disable no-case-declarations */
import { ClientActionTypes } from '../client.action-types'

const initialStates = {
    contacts: [],
    messages: [],
    messagesMetadata: {},
}

const ContactReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case ClientActionTypes.GET_MESSAGES:
            return { ...state, ...action.payload }
        default:
            return { ...state }
    }
}

export default ContactReducer
